import {publish} from '@/script/event.mjs'

export const usePluginCommands = () => {
    const extensions = () => {
        return {
            async cmdPushSave() {
                await this.runAction(
                    async () => {
                        await this.execute(async () => {
                            await this.pushProduct()
                            await this.saveMap()
                            publish(this, 'save')
                        })
                    },

                    {action: '更新制品'}
                )
            },

            async cmdPushSavePublish() {
                await this.runAction(
                    async () => {
                        await this.execute(async () => {
                            if (this.canPushProduct()) {
                                await this.pushProduct()
                            }

                            await this.saveMap()
                            publish(this, 'save')
                            await this.publishProduct()
                        })
                    },

                    {action: '更新&发布制品'}
                )
            },
        }
    }

    return {extensions}
}
